import { render, staticRenderFns } from "./evalItem.vue?vue&type=template&id=4e2d1bb2&scoped=true&"
import script from "./evalItem.vue?vue&type=script&lang=js&"
export * from "./evalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d1bb2",
  null
  
)

export default component.exports